export default "__VITE_ASSET__Db2TZt7P__"